// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_BindingResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_BindingResponse — result of POST /franchisor-channels/trigger-save.
 * Echoes the single binding row after the write (fresh DB state).
 */
import type { FranchisorChannels_BindingRow } from './FranchisorChannels_BindingRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface FranchisorChannels_BindingResponseDados {
row: FranchisorChannels_BindingRow
}

export type FranchisorChannels_BindingResponse = ApiResponse<FranchisorChannels_BindingResponseDados>;

registerResponseContract('FranchisorChannels_BindingResponse', {
  row: {
    type: 'object',
    required: true,
    fields: {
      id:               { type: 'number',  required: true },
      trigger_key:      { type: 'string',  required: false },
      channel_id:       { type: 'number',  required: true },
      channel_type:     { type: 'string',  required: false },
      template_id:      { type: 'number',  required: true },
      recipient_groups: { type: 'array',   required: false },
      enabled:          { type: 'boolean', required: false },
      created_at:       { type: 'string',  required: false },
      updated_at:       { type: 'string',  required: false },
    },
  },
})
